import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { UsersService } from '@app/services/users.service';

@Injectable({ providedIn: 'root' })
export class FilesService {
    private readonly usersService = inject(UsersService);

    public getFileGetUrl(id: string): string {
        // @API file/get
        return `${environment.url.backendApi}/file/get/${id}?token=${this.usersService.accessToken}`;
    }

    public getFileDownloadUrl(id: string, filename: string | null): string {
        const suffix = filename ? `&filename=${encodeURIComponent(filename)}` : '';
        // @API file/download
        return `${environment.url.backendApi}/file/download/${id}?token=${this.usersService.accessToken}${suffix}`;
    }
}
